import React, { Component } from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button, ScrollView } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  criarAgentesRecebedoresDs,
  criarContribuinteDs,
} from "../../DataSources";
import { LoadIndicator } from "devextreme-react/load-indicator";
import showError from "../../AppServices";
import apiAxios from "../../api-axios";
import notify from "devextreme/ui/notify";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";

export default class ArrecadacaoUnificada extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipoData: "credito",
      dataInicial: undefined,
      dataFinal: undefined,
      agenteRecebedorId: undefined,
      tipoBaixa: "T",
      loadIndicatorVisivel: false,
      texto: "Visualizar PDF",
      leiaute: "GERAL",
      exercicio: new Date().getFullYear(),
      origem: "TODOS",
      popupContribuinte: false,
    };

    this.dataOptions = {
      editorType: "dxSelectBox",
      dataSource: [
        { id: "pagamento", descricao: "Data de Pagamento" },
        { id: "credito", descricao: "Data de Crédito" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.leiauteOptions = {
      editorType: "dxSelectBox",
      dataSource: [
        { id: "GERAL", descricao: "Geral" },
        { id: "RECEITA", descricao: "Receita" },
        { id: "CONTABILIDADE", descricao: "Contabilidade" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.origemOptions = {
      editorType: "dxSelectBox",
      dataSource: [
        { id: "TODOS", descricao: "Todos" },
        { id: "TRIBUTOS", descricao: "Tributos" },
        { id: "TAXA", descricao: "Taxa" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.agenteRecebedorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarAgentesRecebedoresDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };

    this.tipoDeBaixaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: "T", descricao: "Todos" },
        { id: "M", descricao: "Manual" },
        { id: "A", descricao: "Automática" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.contribuinteDs = criarContribuinteDs();

    this.ok = this.ok.bind(this);
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);
    this.contribuinteBoxRef = React.createRef();

    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteSeq,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
  }

  setContribuinteId(data) {
    this.setState({ contribuinteSeq: data.value });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.contribuinteSeq]] })
      .then((result) => {
        if (result[0] && result[0].nome) {
          this.setState({ _uiNomeContribuinte: result[0].nome });
        } else {
          this.setState({ _uiNomeContribuinte: "" });
        }
      })
      .catch((_) => this.setState({ _uiNomeContribuinte: "<<ERRO>>" }));
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteSeq: e.row.data.sequencial,
      _uiNomeContribuinte: e.row.data.nome,
      popupContribuinte: false,
    });
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupContribuinte: true });
  }

  ok() {
    this.setState({
      loadIndicatorVisivel: true,
      texto: "Carregando",
    });
    const request = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    apiAxios
      .post("/report/arrecadacao_unificada", {
        ...request,
        responseType: "blob",
      })
      .then((response) => {
        if (response.data.sucesso) {
          const bin = atob(response.data.report);
          const length = bin.length;
          const arrayBuffer = new ArrayBuffer(length);
          const uintArray = new Uint8Array(arrayBuffer);

          for (let i = 0; i < length; i++) {
            uintArray[i] = bin.charCodeAt(i);
          }

          const fileBlob = new Blob([uintArray], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(fileBlob);

          window.open(fileURL, "_blank");
          return true;
        } else {
          notify("Relatório não encontrado.", "error");
          showError(response.data.erros);
          return false;
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          console.log(error);
          showError(error.response.data);
        } else {
          console.log(error);
          showError(error);
        }
      })
      .finally(() => {
        this.setState({
          loadIndicatorVisivel: false,
          texto: "Visualizar PDF",
        });
      });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={4} labelLocation="top">
            <GroupItem
              caption="Relatório de Arrecadações"
              colSpan={4}
              colCount={4}
            >
              <SimpleItem
                dataField={"tipoData"}
                editorType={"dxSelectBox"}
                editorOptions={this.dataOptions}
              >
                <Label text="Tipo de data" />
              </SimpleItem>
              <SimpleItem
                dataField={"leiaute"}
                editorType={"dxSelectBox"}
                editorOptions={this.leiauteOptions}
              >
                <Label text="Leiaute" />
              </SimpleItem>
              <EmptyItem colSpan={2} />
              <SimpleItem
                dataField={"dataInicial"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
              >
                <Label text="Data de Início" />
              </SimpleItem>
              <SimpleItem
                dataField={"dataFinal"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
              >
                <Label text="Data do Fim" />
              </SimpleItem>
              <EmptyItem colSpan={2} />
              <SimpleItem dataField={"exercicio"}>
                <Label text="Exercício" />
              </SimpleItem>
              <SimpleItem
                dataField={"origem"}
                editorType={"dxSelectBox"}
                editorOptions={this.origemOptions}
              >
                <Label text="Origem" />
              </SimpleItem>
              <EmptyItem colSpan={2} />
              <SimpleItem
                dataField={"agenteRecebedorId"}
                editorType={"dxSelectBox"}
                editorOptions={this.agenteRecebedorOptions}
                colSpan={2}
              >
                <Label text="Agente Recebedor" />
              </SimpleItem>
              <EmptyItem colSpan={2} />
              <SimpleItem
                dataField={"tipoBaixa"}
                editorType={"dxSelectBox"}
                editorOptions={this.tipoDeBaixaOptions}
              >
                <Label text="Tipo de Baixa" />
              </SimpleItem>
              <EmptyItem colSpan={3} />
              <SimpleItem colSpan={2} component={this.renderContribuinte}>
                <Label text="Contribuinte" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex" }}>
              <Button
                width={160}
                style={{ display: "inline-block", justifyContent: "center" }}
                type="success"
                disabled={this.state.loadIndicatorVisivel}
                onClick={() => this.ok()}
              >
                <LoadIndicator
                  className="button-indicator"
                  id="small-indicator"
                  height={20}
                  width={20}
                  visible={this.state.loadIndicatorVisivel}
                  style={{ marginRight: "10px", verticalAlign: "middle" }}
                />
                <span className="dx-button-text">{this.state.texto}</span>
              </Button>
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.popupContribuinte}
          onHiding={() => this.setState({ popupContribuinte: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesquisa}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupContribuinte: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }
}
